<template>
    <div class="station-info">
        <vuescroll :ops="scroll">
            <a-row :gutter="16">
                <a-col :span="18">
                    <a-col :span="8" class="row-1">
                        <div class="base-panel">
                            <div class="base-panel-head space-between">
                                <div><a-button type="primary" size="small" class="back" @click="getBack">返回</a-button>总场站数</div>
                                <div><span class="label label-info">{{total}}</span></div>
                            </div>
                            <div class="base-panel-body">
                                <data-tips :data="{num: zccz, title: '正常'}"></data-tips>
                                <data-tips :data="{num: bfzd, title: '部分通讯中断'}" :color="false"></data-tips>
                            </div>
                        </div>
                    </a-col>
                    <a-col :span="8" class="row-1">
                        <div class="base-panel">
                            <div class="base-panel-head space-between">
                                <div>装机容量</div>
                                <div><span class="label label-success">{{zjrl}}Mwp</span></div>
                            </div>
                            <div class="base-panel-body">
                                <data-tips :data="{num: qczd, title: '全场通讯中断'}"></data-tips>
                                <data-tips :data="{num: djr, title: '待接入'}" :color="false"></data-tips>
                            </div>
                        </div>
                    </a-col>
                    <a-col :span="8" class="row-1">
                        <div class="base-panel">
                            <div class="base-panel-head">
                                <div>累计发电量&节约标煤</div>
                            </div>
                            <div class="base-panel-body">
                                <data-tips :data="{num: fdl, title: '累计发电量'}" :unit="'MWh'"></data-tips>
                                <data-tips :data="{num: jybm, title: '节约标煤'}" :unit="'吨'" :color="false"></data-tips>
                            </div>
                        </div>
                    </a-col>
                    <a-col :span="8" class="row-2">
                       <total-p-r ref="totalPR" colorType=1></total-p-r>
                    </a-col>
                    <a-col :span="16" class="row-2">
                        <total-hour></total-hour>
                    </a-col>
                    <a-col :span="16" class="row-2">
                        <power-and-radiation></power-and-radiation>
                    </a-col>
                    <a-col :span="8" class="row-2">
                        <CO2 :data="jnjp"></CO2>
                    </a-col>
                </a-col>
                <a-col :span="6" style="padding-left: 0">
                    <a-col class="row-1"  style="padding-left: 0">
                        <time-rank></time-rank>
                    </a-col>
                    <a-col class="row-3"  style="padding-left: 0">
                        <p-r-rank></p-r-rank>
                    </a-col>
                </a-col>

            </a-row>


        </vuescroll>

    </div>
</template>

<script>
    import dataTips from "../../common/dataTips";
    import timeRank from "../../common/timeRank";
    import vuescroll from 'vuescroll/dist/vuescroll-native';
    import totalPR from "../../common/totalPR";
    import totalHour from "../../common/totalHour";
    import powerAndRadiation from "../../common/powerAndRadiation";
    import CO2 from "../../common/CO2";
    import PRRank from "../../common/PRRank";

    export default {
        name: "stationInfo",
        components:{
          dataTips,
          timeRank,
          vuescroll,
          totalPR,
          totalHour,
          powerAndRadiation,
          CO2,
          PRRank
        },
        data(){
            return {
                groupId: 0,
                total: 0,   //总场站数
                jybm: 0,    //节约标煤 单位kg
                jnjp : 0,   //节能减排 单位kg
                fdl: 0,     //发电量 单位kwh
                zccz: 0,    //正常
                bfzd: 0,    //部分通讯中断
                qczd: 0,    //全场通讯中断
                djr: 0,     //待接入
                zjrl: 0,    //装机容量 单位kwp
                scroll: {
                    vuescroll: {},
                    scrollPanel: {
                        scrollingX: false,
                    },
                    rail: {
                        gutterOfSide: '0px',
                    },
                    bar: {
                        background: '#1ab394',
                    }
                }
            }
        },
        mounted(){
            this.groupId = this.$Utils.getUserStorage().groupId;
            this.getData();
        },
        methods:{
            async getData() {
                let result = await this.$http.get(this.$baseURL.stationInfoByGroupIdForList(this.groupId));
                console.log(result)
                this.total = result.normalNum + result.someDownNum + result.allDownNum + result.stayByNum;
                this.zccz = result.normalNum;
                this.bfzd = result.someDownNum;
                this.qczd = result.allDownNum;
                this.djr = result.stayByNum;
                this.jybm = result.saveStandardCoal / 1000; //化kg为吨
                this.jnjp = result.conserveEnergy / 1000; //化kg为吨
                this.zjrl = result.capacity ; //化kwp为mwp
                this.fdl = result.elecCap / 1000; //化kwh为mwh
                this.$refs.totalPR.loadPR(result.avgPR); //加载PR

            },

            getBack(){
                this.$emit('getBack', 0)
            }
        }
    }
</script>

<style lang="less" scoped>
    .station-info {
        height: 100%;
        background: url('../../../../../public/bg.jpg');
        background-size: 100% 100%;
        color: #eee;
        padding: 12px;
        .row-1 {
            height: 250px;
            margin-bottom: 16px;
        }

        .row-2 {
            height: 300px;
            margin-bottom: 16px;
        }

        .row-3{
            height: 616px;
        }

        .back {
            margin-right: 5px;
        }
    }



</style>
